import React, {useEffect} from 'react';
import Header from '../components/Header';
import MDLogo from '../assets/images/md.png';
import Manufacturer from '../assets/images/manufacturer.png';
import config from '../config';
import '../styles/aboutus.css';

export default function AboutUs() {
    useEffect(() => {
        document.title = "About us"
    }, []);

    return (
        <div className="container">
            <div className="main aboutus mt-3">
                <Header/>
                <p className='heading'>About Us</p>
                <div className='wrapper'>
                    <div className="about-text">
                        <p>AiZtech is a deep-tech company that utilizes cutting-edge AI research to provide a healthcare platform for screening diseases.</p>
                        <p>The iSelfie Test uses your smartphone camera to scan the outer surface of the user’s eyes. It is designed to work on mobile devices (iOS or Android) with at least a 5-megapixel camera.</p>
                    </div>
                    <div className="more-info">
                        <p>For more information, visit: <a className="weblink" target="_blank" rel="noopener noreferrer" href='http://www.AiZtechLabs.com'>www.AiZtechLabs.com</a></p>
                    </div>
                    <div className="more-info">
                        <p>Get in Touch: <a className="weblink" href='mailto:support@aiztechlabs.com'>support@aiztechlabs.com</a></p>
                    </div>
                    <div className="more-text">
                        <img src={MDLogo} alt='Medical Device' />
                        <p>Identification as a Medical Device: {config.aboutUs.medicalDivice.text}</p>
                    </div>

                    <div className="more-text">
                        <img src={Manufacturer} alt='Manufacturer' />
                        <p>Legal Manufacturer: <b>AiZtech Canada Inc.</b></p>
                        <p>Manufacturer’s Address: <b>AiZtech Canada Inc., 510 West Georgia Street, 1800 Vancouver, BC V6B 0M3, Canada</b></p>
                    </div>
                </div>
            </div>
        </div>
    )
}
